import { NgModule } from '@angular/core';
import { TextAvatarDirective } from './text-avatar/text-avatar';
import { DropZoneDirective } from './drop-zone/drop-zone';

@NgModule({
	declarations: [TextAvatarDirective,
    DropZoneDirective],
	imports: [],
	exports: [TextAvatarDirective,
    DropZoneDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts